import React from "react";
import styles from "./difference.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { difference } from "../../../../CONTENT/home";

const Difference = () => (
  <Section tone="ink" id="difference" labelledBy="difference-title">
    <div className={styles.layout}>
      <div className={styles.sticky}>
        <SectionIntro
          id="difference-title"
          eyebrow={difference.eyebrow}
          title={difference.title}
          lead={difference.lead}
        />
      </div>
      <ol className={styles.points}>
        {difference.points.map((p) => (
          <Reveal as="li" key={p.title} className={styles.point}>
            <p className={styles.figure}>
              <span
                className={`${styles.big} ${/\d/.test(p.figure) ? "" : styles.word}`}
              >
                {p.figure}
              </span>
              <span className={styles.unit}>{p.unit}</span>
            </p>
            <div>
              <h3 className={styles.pointTitle}>{p.title}</h3>
              <p className={styles.pointText}>{p.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </Section>
);

export default Difference;
